import type { RouteObject } from 'react-router-dom';

import NotFound from '@/app/error/NotFound';
import Unauthorized from '@/app/error/Unauthorized';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

/**
 * 레이아웃 없이 단독으로 렌더되는 에러 라우트.
 * `*` 라우트는 반드시 mainRoutes의 가장 마지막에 위치해야 함.
 */
export const errorRoutes: RouteObject[] = [
  {
    path: ROUTES.UNAUTHORIZED,
    Component: Unauthorized,
  },
  {
    path: '*',
    Component: NotFound,
  },
];
